import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Flex, Row, Col, Typography  } from 'antd';
import useMobileCheck from '../../../mobile';
import NavBar from '../../../shared/NavBar';
import './HeroSection.css';

import ArrowButton from '../../../shared/ArrowButton/ArrowButton';
import { getAppLoginUrl } from '../../../shared/appUrl';

const { Title, Paragraph } = Typography;

const HeroSection = () => {
  const { pathname } = useLocation();
  const isPulse = pathname === '/pulse' || pathname.startsWith('/pulse/');
  const isReviewedComparison = ['/compare/playwaze-alternative', '/compare/justgo-alternative', '/compare/spond-alternative', '/compare/sportmember-alternative'].includes(pathname);
  const isContentSized = isPulse || isReviewedComparison;
  const isPulseArticle = isPulse && pathname !== '/pulse' && pathname !== '/pulse/all';

  const heroTitle = useSelector(state => state.hero.title)
  const heroContent = useSelector(state => state.hero.content)
  const heroImage = useSelector(state => state.hero.image)
  const hasHeroImage = useSelector(state => state.hero.hasImage)

  const { isMobile } = useMobileCheck();

  return (
    <section 
      className={`hero${isPulse ? ' hero-pulse' : ''}${isReviewedComparison ? ' hero-comparison' : ''}`}
      style={{ 
        height : isContentSized ? "auto" : isMobile ? "calc(100dvh - 30px)" : "auto",
        maxHeight: isContentSized ? "none" : isMobile ? "auto" : "570px"
      }}
      >
      <NavBar />
      <Flex
        style={{ 
          height : isContentSized ? "auto" : isMobile ? "calc(100% - 73px)" : "auto"
        }}
        align="middle"
        justify="space-between"
        className="hero-row"
        vertical={ isMobile ? true : false }
        gap={ isMobile ? 10 : 40 }
      >
        <Flex
          vertical
          style={{ 
            marginBottom: isMobile ? '0px' : '40px', 
            width: isMobile ? '100%' : '50%'
          }}
          className="hero-copy-tmp">
          {isPulseArticle ? <p className="hero-h1">{heroTitle}</p> : <Title className="hero-h1">{heroTitle}</Title>}

          <Paragraph className="hero-lead">
            { heroContent }
          </Paragraph>

          <Flex gap={10} vertical={ isMobile } wrap={isPulse}>
            <ArrowButton 
              href={getAppLoginUrl()}
              data-signup-cta="hero"
              variant="hero">
              Get Started Free
            </ArrowButton>
            <a 
              href="https://apps.apple.com/us/app/shuttleops/id6751508150?itscg=30200&itsct=apps_box_badge&mttnsubad=6751508150" 
              style={ { 
                display: "inline-block" 
              } }
              >
              <img 
                src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/white/en-us?releaseDate=1760572800" 
                alt="Download on the App Store" 
                style={ { 
                  width: "176px",
                  height: "58px",
                  verticalAlign: "middle",
                  objectFit: "contain"
                } } />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.shuttleops&hl=en"
              style={ {
                display: "inline-block"
              } }
              >
              <img
                src="/assets/GetItOnGooglePlay_Badge_Web_color_English.png"
                alt="Download on the Google Play Store"
                style={ {
                  height: "58px",
                  width: "auto",
                  verticalAlign: "middle",
                  objectFit: "contain"
                } } />
            </a>
          </Flex>
        </Flex>
        { !hasHeroImage && <div xs={24} md={12} className={ `default-hero-image ${isMobile ? 'hero-mobile' : '' }` }>
        </div> }

        { hasHeroImage && 
          <Flex 
            style={{ 
              width: isMobile ? '100%' : '50%',
              height: '100%', 
              alignSelf: 'flex-end'
            }}
            className="hero-phone-col">
            <img
              src={heroImage}
              alt="ShuttleOps mobile app"
              className="hero-phone hero-phone-desktop hero-phone-mobile"
            />
        </Flex>}
      </Flex>
    </section>
  )
}

export default HeroSection;
